export const secondsToTimeString = (v) => {
	if(!Number.isInteger(v))
		throw new TypeError('value must be an integer.');
	const minutes = Math.floor(v / 60);
	const seconds = v % 60;

	return `${`00${minutes}`.slice(-2)}:${`00${seconds}`.slice(-2)}`;
};

export default secondsToTimeString;